import { render } from "./Style.vue?vue&type=template&id=5171409e&scoped=true"
import script from "./Style.vue?vue&type=script&lang=js"
export * from "./Style.vue?vue&type=script&lang=js"

import "./Style.vue?vue&type=style&index=0&id=5171409e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5171409e"]])

export default __exports__